import styled from 'styled-components';

export const BookNowPayLaterPersuasionWrap = styled.div(
  props => `
    display:flex;
    padding: 0;
  `,
);

export const BookNowPaylaterRightwrap = styled.div(
  props => `
    padding: 0 0 0 ${props.theme.spacing.small};
  `,
);

export const BookNowPaylaterKnowmoreWrap = styled.div(
  props => `
    display:flex;
    align-items:center;
    font-size: 14px;
  `,
);

export const BookNowPayLaterText = styled.span(
  props => `
    font-size: ${props.theme.font.custom(14)};
    color: ${props.theme.colors.goTeal.dark};
    
  `,
);

export const BookNowPayLaterKnowMoreLink = styled.a(
  props => `
    padding: 0 0 0 ${props.theme.spacing.small};
  `,
);
